/*************************************************/
/* SEARCHBAR                                      /
/*************************************************/

export function searchbar(body) {
    let searchContainers,
        searchTogglers;
    const showSearchClass = 'search-active',
        searchFormButtonClass = 'search-form__button',
        searchBarSelector = '.search-bar',
        searchFormInputSelector = '.search-form__input',
        searchBarToggleSelector = '.search-bar__toggle';

    const init = function () {
        searchContainers = document.querySelectorAll(searchBarSelector);
        if (searchContainers) {
            searchTogglers = document.querySelectorAll(searchBarToggleSelector);
            searchTogglers.forEach(searchToggler => {
                searchToggler.addEventListener('click', e => {
                    e.stopPropagation();
                    if (window.raffleApi) {
                        window.raffleApi.open('9b10b4eb-dee5-4ec3-8f55-cd264dfa9723')

                    } else {
                        const searchContainer = searchToggler.previousElementSibling;
                        if(searchContainer){
                            handleSearchBarVisibility(searchContainer);
                            const searchInput = searchContainer.querySelector(searchFormInputSelector);
                            if (searchInput) {
                                searchInput.focus();
                            }
                        }
                       
                    }
                });
            })

            searchContainers.forEach(searchContainer => {
                searchContainer.addEventListener('click', e => {
                    e.stopPropagation();
                });

                searchContainer.addEventListener('focusout', e => {
                    if (e.target.classList.contains(searchFormButtonClass)) {
                        closeSearch(searchContainer);
                    }
                });
            });


            body.addEventListener('click', e => {
                searchContainers.forEach(searchContainer => {
                    closeSearch(searchContainer);
                });
            });
        }


        function handleSearchBarVisibility(searchContainer) {
            if (!body.classList.contains(showSearchClass)) {
                openSearch(searchContainer);
            } else {
                closeSearch(searchContainer);
            }
        }

        function openSearch(searchContainer) {
            body.classList.add(showSearchClass);
            searchContainer.setAttribute('aria-expanded', true);
        }

        function closeSearch(searchContainer) {
            body.classList.remove(showSearchClass);
            searchContainer.setAttribute('aria-expanded', false);

        }
    };

    init();
}